import React from "react";

const getIngredientCost = (name, amountInGrams, menu) => {
  const item = menu.find(item => item.name.toLowerCase().trim() === name.toLowerCase().trim());
  if (!item || typeof item.pricePerKg === "undefined") {
    console.warn(`⚠️ Missing ingredient or price for: ${name}. Ensure it's in Firestore.`);
    return 0;
  }
  return (parseFloat(item.pricePerKg) / 1000) * amountInGrams;
};

export const calculateCrepeCost = (filling, menu) => {
  let baseCost = getIngredientCost("Dough", 85, menu) +
                 getIngredientCost("Water", 85, menu) +
                 getIngredientCost(filling, 85, menu) +
                 getIngredientCost("Dark sauce", 15, menu) +
                 getIngredientCost("Kinder white", 15, menu);

  if (filling === "Kinder white") {
    baseCost += getIngredientCost("Kinder finger", 25, menu);
  }
  if (filling === "Lotus Biscoff") {
    baseCost += getIngredientCost("Lotus biscuit", 25, menu);
  }
  if (filling === "Oreo Hersheys") {
    baseCost += getIngredientCost("Oreo", 8.5, menu);
  }


  return baseCost;
};

const CrepeCostCalculator = ({ menu }) => {
  return (
    <div className="mt-10 p-6 bg-gray-900 rounded-lg">
      <h2 className="text-2xl font-bold mb-4">Crepe Cost Calculator</h2>
      {["Kinder white", "Yan Yan Fraise", "Lotus Biscoff", "Pistachio Italian", "Nutella", "Dark chocolate", "Oreo Hersheys"].map((filling) => (
        <div key={filling} className="mb-2">
          <h3>{filling}: ${calculateCrepeCost(filling, menu).toFixed(2)}</h3>
        </div>
      ))}
    </div>
  );
};

export default CrepeCostCalculator;
